module.exports = __webpack_public_path__ + "img/mask_airead.aad8117f.png";